import { ScreenObject, NavObject } from '@usacsmideo/types';
import * as Sentry from '@sentry/browser';

/**
 * Converts a NavObject into a validated, sorted array of ScreenObject entries.
 * Filters out the "version" key and any entries missing required properties
 * (id, path, baseOrder). Logs a Sentry breadcrumb when malformed entries are found.
 */
export function getValidScreenArray(navObj: NavObject, label?: string): ScreenObject[] {
  const malformedKeys: string[] = [];
  const screenArr: ScreenObject[] = [];

  for (const key of Object.keys(navObj)) {
    if (key === 'version') continue;
    const value = navObj[key as keyof NavObject];
    if (
      value != null &&
      typeof value === 'object' &&
      typeof (value as Record<string, unknown>).id === 'string' &&
      typeof (value as Record<string, unknown>).path === 'string' &&
      typeof (value as Record<string, unknown>).baseOrder === 'number'
    ) {
      screenArr.push(value as ScreenObject);
    } else {
      malformedKeys.push(key);
    }
  }

  if (malformedKeys.length > 0) {
    Sentry.addBreadcrumb({
      category: 'navigation',
      message: `Filtered ${malformedKeys.length} malformed navObj entries`,
      level: 'warning',
      data: { malformedKeys, source: label },
    });
  }

  return screenArr.sort((a, b) => a.baseOrder - b.baseOrder);
}
